import { render, staticRenderFns } from "./TeamsChronologically.vue?vue&type=template&id=5be352d8&scoped=true&"
import script from "./TeamsChronologically.vue?vue&type=script&lang=js&"
export * from "./TeamsChronologically.vue?vue&type=script&lang=js&"
import style0 from "./TeamsChronologically.vue?vue&type=style&index=0&id=5be352d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be352d8",
  null
  
)

export default component.exports